/**
 * Client ID handling utilities
 * 
 * This file provides centralized utilities for consistent client ID handling
 * across the application.
 */

/**
 * Extract client ID from the URL path or localStorage
 * Follows this priority:
 * 1. URL path segment after "client/" 
 * 2. localStorage key 'selected_client_id'
 * 3. undefined if not found
 */
export const getClientIdFromUrl = () => {
  // Try to get from URL first
  const pathParts = window.location.pathname.split('/');
  const clientIdIndex = pathParts.indexOf('client') + 1;
  
  if (clientIdIndex > 0 && clientIdIndex < pathParts.length) {
    return pathParts[clientIdIndex];
  }
  
  // Fall back to localStorage
  return localStorage.getItem('selected_client_id') || undefined;
};

/**
 * Store client ID in localStorage for persistence
 * @param {string} clientId The client ID to store
 */
export const storeClientId = (clientId) => {
  if (clientId) {
    localStorage.setItem('selected_client_id', clientId);
  }
};

/**
 * Clear stored client ID
 */
export const clearClientId = () => {
  localStorage.removeItem('selected_client_id');
};

/**
 * Log client ID for debugging
 */
export const logClientId = () => {
  const clientId = getClientIdFromUrl();
  console.log(`Current client ID: ${clientId || 'Not set'}`);
  return clientId;
}; 